import React from 'react';
import AnalyticsSummaryCards from './AnalyticsSummaryCards';
import AnalyticsCharts from './AnalyticsCharts';
import LiveSpectatorList from './LiveSpectatorList';

export default function UserAnalytics({ messages, users, onlineCount }) {
  const totalMessages = messages.length;

  return (
    <div className="space-y-6">
      {/* 4 Tarjetas de Métricas Principales */}
      <AnalyticsSummaryCards
        onlineCount={onlineCount}
        totalMessages={totalMessages}
        messages={messages}
        users={users}
      />

      {/* Gráficos SVG de Tendencias y Dispositivos */}
      <AnalyticsCharts messages={messages} />

      {/* Listado Detallado de Espectadores con Ping y Procedencia */}
      <LiveSpectatorList users={users} />
    </div>
  );
}